export default __webpack_public_path__ + "static/LittlePrinceKing-79920b5d7ec13eecce2f689a406a7c0d.png";